export const checkProjectType = () => {
    return !process.env.REACT_APP_PROJECT.includes('nani');
}